import { toast } from "react-toastify";

export const handleError = async ({ err, setError }) => {
  const response = err?.response?.data ?? {};

  if (response.detail) {
    toast.error(response.detail);
  } else if (response && typeof response === "object") {
    if (setError) {
      for (const key in response) {
        setError(key, {
          type: "custom",
          message: response[key],
        });
      }
    }
  } else {
    toast.error("مشکلی در سمت سرور پیش آمده");
  }
};
